import { SearchIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

import { Input } from '../input/input'

export interface SearchInputProps {
  value: string
  placeholder?: string
  showsIcon?: boolean
  className?: {
    root?: string
    input?: string
  }
  onChange: (value: string) => void
}

export const SearchInput = ({
  value,
  placeholder = 'Search',
  showsIcon = true,
  className,
  onChange,
}: SearchInputProps) => {
  return (
    <div className={cn('relative', 'flex items-center gap-x-2', 'w-fit', className?.root)}>
      <Input
        value={value}
        placeholder={placeholder}
        className={cn(
          {
            'relative pl-9 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2':
              showsIcon,
          },
          className?.input
        )}
        onChange={(e) => onChange(e.target.value)}
      />
      {showsIcon && (
        <SearchIcon size={16} className={cn('absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground')} />
      )}
    </div>
  )
}
